(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alter-ego-lifestyle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initSection(section) {
      if (!section || !section.hasAttribute('data-alter-ego-lifestyle-section')) return;

      const swiperElement = section.querySelector('[data-lifestyle-swiper]');
      const pagination = section.querySelector('[data-pagination]');
      const paginationBars = section.querySelectorAll('[data-pagination-index]');

      let swiperInstance = null;
      let currentIsMobile = window.innerWidth <= 767;
      let resizeTimeout;
      let firstVideoAutoplayStarted = false;

      function destroySwiper() {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }

      function initSwiper() {
        if (!swiperElement || typeof Swiper === 'undefined') {
          if (typeof Swiper === 'undefined') {
            setTimeout(initSwiper, 100);
          }
          return;
        }

        destroySwiper();

        const isMobile = window.innerWidth <= 767;
        const slidesPerView = isMobile ? 1 : 3;
        const spaceBetween = 8;
        const allowSlide = isMobile;

        swiperInstance = new Swiper(swiperElement, {
          slidesPerView: slidesPerView,
          spaceBetween: spaceBetween,
          loop: false,
          speed: 300,
          allowTouchMove: allowSlide,
          allowSlideNext: allowSlide,
          allowSlidePrev: allowSlide,
          on: {
            init: function () {
              updatePagination(this.activeIndex);
            },
            slideChange: function () {
              updatePagination(this.activeIndex);
              pauseVideosInInactiveSlides(this);
              if (window.innerWidth <= 767 && this.slides && this.slides[this.activeIndex]) {
                const activeSlide = this.slides[this.activeIndex];
                if (activeSlide.querySelector('.alter-ego-lifestyle__video')) {
                  playVideoInSlide(activeSlide, true);
                }
              }
            },
            resize: function () {
              const newIsMobile = window.innerWidth <= 767;
              this.params.slidesPerView = newIsMobile ? 1 : 3;
              this.params.allowTouchMove = newIsMobile;
              this.params.allowSlideNext = newIsMobile;
              this.params.allowSlidePrev = newIsMobile;
              this.update();
              updatePagination(this.activeIndex);
            },
          },
        });
      }

      function updatePagination(activeIndex) {
        paginationBars.forEach(function (bar, index) {
          const isActive = index === activeIndex;
          bar.classList.toggle('alter-ego-lifestyle__pagination-bar--active', isActive);
          bar.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      paginationBars.forEach(function (bar, index) {
        bar.addEventListener('click', function () {
          if (swiperInstance) {
            swiperInstance.slideTo(index);
            updatePagination(index);
          }
        });
      });

      function pauseVideoInSlide(slideElement) {
        if (!slideElement) return;

        const videoElement = slideElement.querySelector('.alter-ego-lifestyle__video');
        if (!videoElement || videoElement.paused) return;

        const videoId = videoElement.id;
        const buttonId = videoId.replace('lifestyle-video-', '');

        const playButton = section.querySelector('[data-play-button="' + buttonId + '"]');
        const pauseButton = section.querySelector('[data-pause-button="' + buttonId + '"]');
        const muteButton = section.querySelector('[data-mute-button="' + buttonId + '"]');
        const overlay = section.querySelector('[data-overlay="' + buttonId + '"]');

        videoElement.pause();

        if (playButton) {
          playButton.classList.remove('hidden');
        }

        if (overlay) {
          overlay.classList.remove('hidden');
        }

        if (pauseButton) {
          pauseButton.classList.remove('active');
        }

        if (muteButton) {
          muteButton.classList.remove('active');
        }
      }

      function pauseVideosInInactiveSlides(swiper) {
        if (!swiper || !swiper.slides) return;

        const activeIndex = swiper.activeIndex;
        const slidesPerView = swiper.params.slidesPerView || 1;

        swiper.slides.forEach(function (slide, index) {
          const isInActiveView = index >= activeIndex && index < activeIndex + slidesPerView;

          if (!isInActiveView) {
            pauseVideoInSlide(slide);
          }
        });
      }

      function playVideoInSlide(slideEl, muteForAutoplay) {
        if (!slideEl) return;
        const videoElement = slideEl.querySelector('.alter-ego-lifestyle__video');
        if (!videoElement) return;

        const muteAndHide = section.getAttribute('data-mute-and-hide-control') === 'true';
        const buttonId = videoElement.id.replace('lifestyle-video-', '');
        const playButton = section.querySelector('[data-play-button="' + buttonId + '"]');
        const pauseButton = section.querySelector('[data-pause-button="' + buttonId + '"]');
        const muteButton = section.querySelector('[data-mute-button="' + buttonId + '"]');
        const overlay = section.querySelector('[data-overlay="' + buttonId + '"]');
        const thumbnail = section.querySelector('[data-thumbnail="' + buttonId + '"]');

        section.querySelectorAll('.alter-ego-lifestyle__video').forEach(function (video) {
          if (video.id !== videoElement.id && !video.paused) {
            const otherButtonId = video.id.replace('lifestyle-video-', '');
            const otherSlide = video.closest('.swiper-slide');
            if (otherSlide) pauseVideoInSlide(otherSlide);
          }
        });

        if (thumbnail) thumbnail.classList.add('hidden');
        if (playButton) {
          playButton.classList.add('hidden');
          playButton.classList.remove('alter-ego-lifestyle__play-button--centered');
        }
        if (pauseButton) pauseButton.classList.add('active');
        if (muteButton && !muteAndHide) {
          muteButton.classList.add('active');
          muteButton.classList.toggle('is-muted', videoElement.muted);
        }
        if (muteForAutoplay) videoElement.muted = true;
        if (overlay) overlay.classList.add('hidden');
        videoElement.style.display = 'block';
        videoElement.play().catch(function (err) {
          console.error('Error playing video:', err);
        });
      }

      function startDesktopAutoplay() {
        if (window.innerWidth <= 767 || !swiperInstance || !swiperInstance.slides.length) return;
        const firstSlide = swiperInstance.slides[0];
        if (firstSlide && firstSlide.querySelector('.alter-ego-lifestyle__video')) {
          playVideoInSlide(firstSlide, true);
        }
      }

      function stopAllVideos() {
        if (!swiperInstance || !swiperInstance.slides) return;
        swiperInstance.slides.forEach(function (slide) {
          pauseVideoInSlide(slide);
        });
      }

      function startFirstVideoWhenInView() {
        if (firstVideoAutoplayStarted) return;
        firstVideoAutoplayStarted = true;
        if (window.innerWidth > 767) {
          startDesktopAutoplay();
        } else if (
          swiperInstance &&
          swiperInstance.slides[0] &&
          swiperInstance.slides[0].querySelector('.alter-ego-lifestyle__video')
        ) {
          playVideoInSlide(swiperInstance.slides[0], true);
        }
      }

      function setupViewportAutoplay() {
        const observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting || firstVideoAutoplayStarted) return;
              startFirstVideoWhenInView();
              observer.disconnect();
            });
          },
          { rootMargin: '0px', threshold: 0.25 },
        );
        if (section) observer.observe(section);
      }

      function initVideoControls() {
        const muteAndHide = section.getAttribute('data-mute-and-hide-control') === 'true';
        const playButtons = section.querySelectorAll('[data-play-button]');
        const pauseButtons = section.querySelectorAll('[data-pause-button]');
        const videos = section.querySelectorAll('.alter-ego-lifestyle__video');

        videos.forEach(function (video) {
          const videoId = video.id;
          const buttonId = videoId.replace('lifestyle-video-', '');
          const overlay = section.querySelector('[data-overlay="' + buttonId + '"]');
          const thumbnail = section.querySelector('[data-thumbnail="' + buttonId + '"]');
          const playButton = section.querySelector('[data-play-button="' + buttonId + '"]');
          const pauseButton = section.querySelector('[data-pause-button="' + buttonId + '"]');

          video.loop = false;
          if (muteAndHide) {
            video.muted = true;
          }

          if (overlay) {
            video.addEventListener('play', function () {
              overlay.classList.add('hidden');
            });

            video.addEventListener('pause', function () {
              overlay.classList.remove('hidden');
            });
          }

          const muteButton = section.querySelector('[data-mute-button="' + buttonId + '"]');
          if (muteButton && !muteAndHide) {
            video.addEventListener('play', function () {
              muteButton.classList.add('active');
              muteButton.classList.toggle('is-muted', video.muted);
            });
            video.addEventListener('pause', function () {
              muteButton.classList.remove('active');
            });
          }

          video.addEventListener('ended', function () {
            video.style.display = 'none';

            if (thumbnail) {
              thumbnail.classList.remove('hidden');
            }

            if (playButton) {
              playButton.classList.remove('hidden');
              playButton.classList.add('alter-ego-lifestyle__play-button--centered');
            }

            if (overlay) {
              overlay.classList.remove('hidden');
            }

            if (pauseButton) {
              pauseButton.classList.remove('active');
            }

            if (muteButton) {
              muteButton.classList.remove('active');
            }

            video.currentTime = 0;

            if (
              window.innerWidth > 767 &&
              swiperInstance &&
              swiperInstance.slides &&
              swiperInstance.slides.length > 1
            ) {
              const slide = video.closest('.swiper-slide');
              if (slide) {
                const slides = Array.from(section.querySelectorAll('.swiper-slide'));
                const currentIndex = slides.indexOf(slide);
                const nextIndex = (currentIndex + 1) % slides.length;
                const nextSlide = slides[nextIndex];
                if (nextSlide && nextSlide.querySelector('.alter-ego-lifestyle__video')) {
                  setTimeout(function () {
                    playVideoInSlide(nextSlide, true);
                  }, 300);
                }
              }
            }
          });
        });

        playButtons.forEach(function (playButton) {
          playButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const buttonId = playButton.getAttribute('data-play-button');
            const videoId = 'lifestyle-video-' + buttonId;
            const thumbnail = section.querySelector('[data-thumbnail="' + buttonId + '"]');
            const pauseButton = section.querySelector('[data-pause-button="' + buttonId + '"]');
            const overlay = section.querySelector('[data-overlay="' + buttonId + '"]');
            const videoElement = document.getElementById(videoId);

            if (!videoElement) return;

            const allVideos = section.querySelectorAll('.alter-ego-lifestyle__video');
            allVideos.forEach(function (video) {
              if (video.id !== videoId && !video.paused) {
                const otherButtonId = video.id.replace('lifestyle-video-', '');
                const otherPlayButton = section.querySelector('[data-play-button="' + otherButtonId + '"]');
                const otherPauseButton = section.querySelector('[data-pause-button="' + otherButtonId + '"]');
                const otherMuteButton = section.querySelector('[data-mute-button="' + otherButtonId + '"]');
                const otherOverlay = section.querySelector('[data-overlay="' + otherButtonId + '"]');

                video.pause();

                if (otherPlayButton) {
                  otherPlayButton.classList.remove('hidden');
                }

                if (otherOverlay) {
                  otherOverlay.classList.remove('hidden');
                }

                if (otherPauseButton) {
                  otherPauseButton.classList.remove('active');
                }

                if (otherMuteButton) {
                  otherMuteButton.classList.remove('active');
                }
              }
            });

            if (thumbnail) {
              thumbnail.classList.add('hidden');
            }
            playButton.classList.add('hidden');
            playButton.classList.remove('alter-ego-lifestyle__play-button--centered');

            if (pauseButton) {
              pauseButton.classList.add('active');
            }

            const muteButton = section.querySelector('[data-mute-button="' + buttonId + '"]');
            if (muteButton && !muteAndHide) {
              muteButton.classList.add('active');
              muteButton.classList.toggle('is-muted', videoElement.muted);
            }
            if (muteAndHide) {
              videoElement.muted = true;
            }

            if (overlay) {
              overlay.classList.add('hidden');
            }

            videoElement.style.display = 'block';
            videoElement.play().catch(function (err) {
              console.error('Error playing video:', err);
            });
          });
        });

        pauseButtons.forEach(function (pauseButton) {
          pauseButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const buttonId = pauseButton.getAttribute('data-pause-button');
            const videoId = 'lifestyle-video-' + buttonId;
            const playButton = section.querySelector('[data-play-button="' + buttonId + '"]');
            const overlay = section.querySelector('[data-overlay="' + buttonId + '"]');
            const videoElement = document.getElementById(videoId);

            if (!videoElement) return;

            videoElement.pause();

            if (playButton) {
              playButton.classList.remove('hidden');
            }

            if (overlay) {
              overlay.classList.remove('hidden');
            }

            pauseButton.classList.remove('active');

            const muteButton = section.querySelector('[data-mute-button="' + buttonId + '"]');
            if (muteButton) {
              muteButton.classList.remove('active');
            }
          });
        });

        const muteButtons = section.querySelectorAll(
          '[data-mute-button]:not(.alter-ego-lifestyle__mute-button--hidden-by-setting)',
        );
        muteButtons.forEach(function (muteButton) {
          muteButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const buttonId = muteButton.getAttribute('data-mute-button');
            const videoId = 'lifestyle-video-' + buttonId;
            const videoElement = document.getElementById(videoId);

            if (!videoElement) return;

            videoElement.muted = !videoElement.muted;
            muteButton.classList.toggle('is-muted', videoElement.muted);
            muteButton.setAttribute('aria-label', videoElement.muted ? 'Unmute video' : 'Mute video');
          });
        });

        section.querySelectorAll('.alter-ego-lifestyle__video-wrapper').forEach(function (wrapper) {
          wrapper.addEventListener('click', function (e) {
            if (window.innerWidth > 767) return;
            if (
              e.target.closest(
                '.alter-ego-lifestyle__play-button, .alter-ego-lifestyle__pause-button, .alter-ego-lifestyle__mute-button, .alter-ego-lifestyle__product-info',
              )
            )
              return;

            const videoElement = wrapper.querySelector('.alter-ego-lifestyle__video');
            if (!videoElement) return;

            const buttonId = videoElement.id.replace('lifestyle-video-', '');
            const playButton = section.querySelector('[data-play-button="' + buttonId + '"]');
            const pauseButton = section.querySelector('[data-pause-button="' + buttonId + '"]');
            const muteButton = section.querySelector('[data-mute-button="' + buttonId + '"]');
            const thumbnail = section.querySelector('[data-thumbnail="' + buttonId + '"]');
            const overlay = section.querySelector('[data-overlay="' + buttonId + '"]');

            if (videoElement.paused) {
              if (muteAndHide) {
                videoElement.muted = true;
              }
              const allVideos = section.querySelectorAll('.alter-ego-lifestyle__video');
              allVideos.forEach(function (video) {
                if (video.id !== videoElement.id && !video.paused) {
                  const otherButtonId = video.id.replace('lifestyle-video-', '');
                  const otherPlayButton = section.querySelector('[data-play-button="' + otherButtonId + '"]');
                  const otherPauseButton = section.querySelector('[data-pause-button="' + otherButtonId + '"]');
                  const otherOverlay = section.querySelector('[data-overlay="' + otherButtonId + '"]');
                  const otherMuteButton = section.querySelector('[data-mute-button="' + otherButtonId + '"]');
                  video.pause();
                  if (otherPlayButton) otherPlayButton.classList.remove('hidden');
                  if (otherOverlay) otherOverlay.classList.remove('hidden');
                  if (otherPauseButton) otherPauseButton.classList.remove('active');
                  if (otherMuteButton) otherMuteButton.classList.remove('active');
                }
              });
              if (thumbnail) thumbnail.classList.add('hidden');
              if (playButton) playButton.classList.add('hidden');
              if (pauseButton) pauseButton.classList.add('active');
              if (muteButton && !muteAndHide) {
                muteButton.classList.add('active');
                muteButton.classList.toggle('is-muted', videoElement.muted);
              }
              if (overlay) overlay.classList.add('hidden');
              videoElement.style.display = 'block';
              videoElement.play().catch(function (err) {
                console.error('Error playing video:', err);
              });
            } else {
              videoElement.pause();
              if (playButton) playButton.classList.remove('hidden');
              if (overlay) overlay.classList.remove('hidden');
              if (pauseButton) pauseButton.classList.remove('active');
              if (muteButton) muteButton.classList.remove('active');
            }
          });
        });
      }

      function handleResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
          const newIsMobile = window.innerWidth <= 767;

          if (newIsMobile !== currentIsMobile) {
            currentIsMobile = newIsMobile;
            stopAllVideos();
            destroySwiper();
            initSwiper();
          } else if (swiperInstance) {
            swiperInstance.update();
          }
        }, 150);
      }

      initSwiper();
      initVideoControls();
      setupViewportAutoplay();
      window.addEventListener('resize', handleResize);
    }

    function initAll() {
      document.querySelectorAll('[data-alter-ego-lifestyle-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      const section = document.querySelector(
        '[data-alter-ego-lifestyle-section][data-section-id="' + e.detail.sectionId + '"]',
      );
      if (section) {
        initSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auto-scroll-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initSection(section) {
      const marquee = section.querySelector('[data-marquee]');
      const track = section.querySelector('[data-track]');
      if (!marquee || !track) return;

      const scrollSpeedSec = parseInt(section.dataset.scrollSpeed, 10) || 30;
      const direction = section.dataset.scrollDirection || 'right_to_left';
      const reverse = direction === 'left_to_right';

      const LOOP_COPIES = 5;

      const reducedMotion =
        typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let trackWidth = 0;
      let loopWidth = 0;
      let marqueeWidth = 0;
      let minOffset = 0;
      let maxOffset = 0;
      let cycleMs = scrollSpeedSec * 1000;
      let virtualOffset = 0;
      let startTime = Date.now();
      let rafId = null;
      let isDragging = false;
      let hasDragged = false;
      let startX = 0;
      let startY = 0;
      let startOffset = 0;
      let activePointerId = -1;
      let isPausedByHover = false;
      let hasPointerCapture = false;

      function measure() {
        trackWidth = track.offsetWidth;
        marqueeWidth = marquee.offsetWidth;
        maxOffset = 0;
        minOffset = Math.min(0, -(trackWidth - marqueeWidth));
        var cards = track.querySelectorAll('.auto-scroll-products__product-card');
        if (cards.length >= LOOP_COPIES * 2) {
          var cardsPerCopy = cards.length / LOOP_COPIES;
          var secondCopyStart = cards[Math.floor(cardsPerCopy)];
          if (secondCopyStart) {
            loopWidth = Math.round(secondCopyStart.offsetLeft);
          } else {
            loopWidth = Math.round(trackWidth / LOOP_COPIES);
          }
        } else {
          loopWidth = Math.round(trackWidth / LOOP_COPIES);
        }
      }

      function clampOffset(value) {
        return Math.max(minOffset, Math.min(maxOffset, value));
      }

      function tick() {
        if (isDragging || isPausedByHover || reducedMotion) return;
        if (loopWidth <= 0) {
          rafId = requestAnimationFrame(tick);
          return;
        }
        var elapsed = Date.now() - startTime;
        var totalDistance = (elapsed / cycleMs) * loopWidth;
        var offsetInLoop = totalDistance % loopWidth;
        if (offsetInLoop < 0) offsetInLoop += loopWidth;
        virtualOffset = reverse ? offsetInLoop : -offsetInLoop;
        var px = Math.round(virtualOffset);
        if (px === -loopWidth || px === loopWidth) px = 0;
        track.style.transform = 'translateX(' + px + 'px)';
        rafId = requestAnimationFrame(tick);
      }

      function startAnimation() {
        measure();
        if (loopWidth <= 0) return;
        startTime = Date.now();
        rafId = requestAnimationFrame(tick);
      }

      function endDrag() {
        if (!isDragging) return;
        isDragging = false;
        hasPointerCapture = false;
        marquee.classList.remove('is-dragging');
        try {
          marquee.releasePointerCapture(activePointerId);
        } catch (e) {}
        measure();
        virtualOffset = clampOffset(virtualOffset);
        track.style.transform = 'translateX(' + virtualOffset + 'px)';
        const progress = reverse ? virtualOffset / loopWidth : -virtualOffset / loopWidth;
        const normalized = ((progress % 1) + 1) % 1;
        startTime = Date.now() - normalized * cycleMs;
        if (!isPausedByHover) {
          rafId = requestAnimationFrame(tick);
        }
        setTimeout(function () {
          hasDragged = false;
        }, 0);
      }

      marquee.addEventListener(
        'pointerdown',
        function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          hasDragged = false;
          isDragging = true;
          hasPointerCapture = false;
          activePointerId = e.pointerId;
          startX = e.clientX;
          startY = e.clientY;
          measure();
          startOffset = clampOffset(virtualOffset);
          virtualOffset = startOffset;
          track.style.transform = 'translateX(' + virtualOffset + 'px)';
          marquee.classList.add('is-dragging');
          if (rafId) cancelAnimationFrame(rafId);
          rafId = null;
          if (e.pointerType === 'touch') {
            marquee.setPointerCapture(e.pointerId);
            hasPointerCapture = true;
          }
        },
        { passive: true },
      );

      marquee.addEventListener(
        'pointermove',
        function (e) {
          if (!isDragging) return;
          const deltaX = e.clientX - startX;
          const deltaY = e.clientY - startY;
          if (e.pointerType === 'mouse') {
            if (!hasPointerCapture) {
              const isHorizontal = Math.abs(deltaY) <= Math.abs(deltaX) * 2;
              if (!isHorizontal) return;
              hasPointerCapture = true;
              hasDragged = true;
              marquee.setPointerCapture(e.pointerId);
            }
          } else {
            hasDragged = true;
          }
          if (e.pointerType === 'touch') e.preventDefault();
          measure();
          const delta = reverse ? -deltaX : deltaX;
          virtualOffset = clampOffset(startOffset + delta);
          track.style.transform = 'translateX(' + virtualOffset + 'px)';
        },
        { passive: false },
      );

      marquee.addEventListener('pointerup', endDrag);
      marquee.addEventListener('pointercancel', endDrag);
      function resumeAnimation() {
        if (!isPausedByHover) return;
        isPausedByHover = false;
        measure();
        const progress = reverse ? virtualOffset / loopWidth : -virtualOffset / loopWidth;
        const normalized = ((progress % 1) + 1) % 1;
        startTime = Date.now() - normalized * cycleMs;
        rafId = requestAnimationFrame(tick);
      }

      marquee.addEventListener('pointerleave', function (e) {
        if (isDragging && e.pointerId === activePointerId) endDrag();
        if (e.pointerType === 'mouse') resumeAnimation();
      });

      marquee.addEventListener('mouseleave', function () {
        resumeAnimation();
      });

      marquee.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') {
          isPausedByHover = true;
          if (rafId) {
            cancelAnimationFrame(rafId);
            rafId = null;
          }
        }
      });

      marquee.addEventListener(
        'click',
        function (e) {
          if (hasDragged) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          const card = e.target.closest('.auto-scroll-products__product-card');
          if (card && card.href) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = card.href;
          }
        },
        true,
      );

      if (!reducedMotion) {
        startAnimation();
        window.addEventListener('resize', function () {
          if (!isDragging && loopWidth > 0) {
            measure();
            const progress = reverse ? virtualOffset / loopWidth : -virtualOffset / loopWidth;
            const normalized = ((progress % 1) + 1) % 1;
            startTime = Date.now() - normalized * cycleMs;
          }
        });
      }
    }

    function initAll() {
      document.querySelectorAll('[data-auto-scroll-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      const section = document.querySelector(
        '[data-auto-scroll-section][data-section-id="' + e.detail.sectionId + '"]',
      );
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  // Minimal Slick: mobile only
  (function() {
    function init() {
      if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) return;
      var $ = jQuery;
      var $grids = $('.aer-blog-posts .js-blog-posts');
      $grids.each(function() {
        var $el = $(this);
        if ($el.hasClass('slick-initialized')) return;
        $el.slick({
          mobileFirst: true,
          slidesToShow: 1.2,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          infinite: false,
          adaptiveHeight: true,
          responsive: [
            { breakpoint: 769, settings: 'unslick' }
          ]
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-init after resize when returning to mobile from desktop
    window.addEventListener('resize', function() {
      if (window.innerWidth < 769) {
        init();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const MOBILE_BREAKPOINT = 749;
    const swiperInstances = new Map();

    function updateNoHoverSwapAll() {
      document.querySelectorAll('[data-ctab-section]').forEach(function (section) {
        if (window.innerWidth <= MOBILE_BREAKPOINT) {
          section.classList.add('ctab--no-hover-swap');
        } else {
          section.classList.remove('ctab--no-hover-swap');
        }
      });
    }

    function initCtabSwiper(swiperElement, sectionId, tabLabel) {
      if (!swiperElement) return;

      if (typeof Swiper === 'undefined') {
        setTimeout(function () {
          initCtabSwiper(swiperElement, sectionId, tabLabel);
        }, 100);
        return;
      }

      const instanceKey = sectionId + '-' + tabLabel;
      if (swiperInstances.has(instanceKey)) {
        const existingSwiper = swiperInstances.get(instanceKey);
        if (existingSwiper && existingSwiper.destroy) {
          existingSwiper.destroy(true, true);
        }
      }
      swiperElement._ctabSwiper = null;

      const panel = swiperElement.closest('.ctab__panel');
      const paginationEl = panel ? panel.querySelector('.swiper-pagination') : null;
      const progressBar = panel ? panel.querySelector('[data-progress-bar]') : null;
      const progressBarFill = progressBar ? progressBar.querySelector('.ctab__progress-bar') : null;

      var accumulatedWheelDelta = 0;
      var wheelRafId = null;

      function updateProgressBar(swiper, progressOverride) {
        if (!progressBarFill || !swiper) return;
        const thumbWidthPercent = 20;
        const maxLeft = 100 - thumbWidthPercent;
        let progress =
          progressOverride !== undefined
            ? Math.min(1, Math.max(0, progressOverride))
            : Math.min(1, Math.max(0, swiper.progress));
        if (Number.isNaN(progress) || !Number.isFinite(progress)) progress = 0;
        const leftPct = progress * maxLeft;
        progressBarFill.style.left = leftPct + '%';
      }

      function applyProgressToSwiper(swiper, progress) {
        if (!swiper || swiper.slides.length <= 1) return;
        var swiperMin = swiper.minTranslate();
        var swiperMax = swiper.maxTranslate();
        var minT = Math.min(swiperMin, swiperMax);
        var maxT = Math.max(swiperMin, swiperMax);
        var currentT = typeof swiper.getTranslate === 'function' ? swiper.getTranslate() : swiper.translate;
        var newT = maxT + progress * (minT - maxT);
        if (typeof swiper.setTransition === 'function') swiper.setTransition(0);
        swiper.setTranslate(newT);
        updateProgressBar(swiper, progress);
      }

      function setupProgressBarDrag(progressBarEl, swiper) {
        if (!progressBarEl || !swiper) return;
        if (progressBarEl._ctabProgressDragSetup) {
          progressBarEl._ctabProgressSwiper = swiper;
          return;
        }
        progressBarEl._ctabProgressDragSetup = true;
        progressBarEl._ctabProgressSwiper = swiper;

        function getProgress(clientX) {
          var rect = progressBarEl.getBoundingClientRect();
          var p = (clientX - rect.left) / rect.width;
          return Math.min(1, Math.max(0, p));
        }

        var activePointerId = null;
        var dragRafId = null;
        var lastDragClientX = null;

        function applyDragFrame() {
          dragRafId = null;
          var x = lastDragClientX;
          if (x == null) return;
          var s = progressBarEl._ctabProgressSwiper;
          if (!s) return;
          var progress = getProgress(x);
          applyProgressToSwiper(s, progress);
        }

        function onPointerMove(e) {
          if (e.pointerType === 'touch') e.preventDefault();
          lastDragClientX = e.clientX;
          if (dragRafId != null) return;
          dragRafId = requestAnimationFrame(applyDragFrame);
        }

        function endDrag(e) {
          if (activePointerId !== null && e.pointerId !== activePointerId) return;
          activePointerId = null;
          lastDragClientX = null;
          if (dragRafId != null) {
            cancelAnimationFrame(dragRafId);
            dragRafId = null;
          }
          progressBarEl.classList.remove('is-dragging');
          try {
            progressBarEl.releasePointerCapture(e.pointerId);
          } catch (err) {}
          progressBarEl.removeEventListener('pointermove', onPointerMove);
          progressBarEl.removeEventListener('pointerup', endDrag);
          progressBarEl.removeEventListener('pointercancel', endDrag);
          progressBarEl.removeEventListener('pointerleave', onPointerLeave);
          var s = progressBarEl._ctabProgressSwiper;
          if (s && s.slides.length > 1) {
            if (typeof s.setTransition === 'function') s.setTransition(300);
            var progress = Math.min(1, Math.max(0, s.progress));
            if (Number.isNaN(progress) || !Number.isFinite(progress)) progress = 0;
            updateProgressBar(s, progress);
          }
        }

        function onPointerLeave(e) {
          if (activePointerId !== null && e.pointerId === activePointerId) endDrag(e);
        }

        progressBarEl.addEventListener(
          'pointerdown',
          function (e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            if (e.cancelable) e.preventDefault();
            activePointerId = e.pointerId;
            progressBarEl.classList.add('is-dragging');
            var progress = getProgress(e.clientX);
            applyProgressToSwiper(progressBarEl._ctabProgressSwiper, progress);
            progressBarEl.setPointerCapture(e.pointerId);
            progressBarEl.addEventListener('pointermove', onPointerMove, { passive: false });
            progressBarEl.addEventListener('pointerup', endDrag);
            progressBarEl.addEventListener('pointercancel', endDrag);
            progressBarEl.addEventListener('pointerleave', onPointerLeave);
          },
          { passive: false },
        );
      }

      var swiper = new Swiper(swiperElement, {
        initialSlide: 0,
        slidesPerView: 'auto',
        spaceBetween: 8,
        loop: false,
        grabCursor: true,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
            }
          : false,
        on: {
          init: function () {
            var s = this;
            updateProgressBar(s);
            if (progressBar) setupProgressBarDrag(progressBar, s);
            if (swiperElement._ctabWheelAdded) return;
            swiperElement._ctabWheelAdded = true;
            swiperElement.addEventListener(
              'wheel',
              function (e) {
                var s = swiperElement._ctabSwiper;
                if (!s || typeof s.minTranslate !== 'function') return;
                var isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
                if (!isHorizontal) return;
                var rawDelta = -e.deltaX;
                var sensitivity = 11;
                accumulatedWheelDelta += rawDelta * sensitivity;
                if (Math.abs(accumulatedWheelDelta) < 0.5) return;
                e.preventDefault();
                if (wheelRafId == null) {
                  wheelRafId = requestAnimationFrame(function applyWheelFrame() {
                    wheelRafId = null;
                    s = swiperElement._ctabSwiper;
                    if (!s || Math.abs(accumulatedWheelDelta) < 0.5) return;
                    var swiperMin = s.minTranslate();
                    var swiperMax = s.maxTranslate();
                    var minT = Math.min(swiperMin, swiperMax);
                    var maxT = Math.max(swiperMin, swiperMax);
                    var t = typeof s.getTranslate === 'function' ? s.getTranslate() : s.translate;
                    var delta = accumulatedWheelDelta;
                    accumulatedWheelDelta = 0;
                    var newT = t + delta;
                    newT = Math.max(minT, Math.min(maxT, newT));
                    var progress = maxT !== minT ? (newT - maxT) / (minT - maxT) : 0;
                    if (typeof s.setTransition === 'function') s.setTransition(0);
                    s.setTranslate(newT);
                    if (typeof s.setTransition === 'function') s.setTransition(300);
                    updateProgressBar(s, progress);
                  });
                }
              },
              { passive: false },
            );
          },
          slideChange: function () {
            updateProgressBar(this);
          },
          progress: function () {
            updateProgressBar(this);
          },
        },
      });

      swiperElement._ctabSwiper = swiper;
      swiperInstances.set(instanceKey, swiper);
    }

    function initSection(section) {
      if (!section) return;

      updateNoHoverSwapAll();

      const tabTriggers = section.querySelectorAll('[data-ctab-trigger]');
      const tabPanels = section.querySelectorAll('[data-ctab-panel]');

      function initAllSwipers() {
        tabPanels.forEach(function (panel) {
          const swiperElement = panel.querySelector('.ctab__swiper');
          if (swiperElement) {
            const sectionId = swiperElement.dataset.sectionId;
            const tabLabel = swiperElement.dataset.tab;
            const instanceKey = sectionId + '-' + tabLabel;
            if (!swiperInstances.has(instanceKey)) {
              initCtabSwiper(swiperElement, sectionId, tabLabel);
            }
          }
        });
      }

      function switchTab(tab) {
        tabTriggers.forEach(function (triggerButton) {
          const isActive = triggerButton.getAttribute('data-tab') === tab;
          triggerButton.classList.toggle('ctab__tab--active', isActive);
          triggerButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        tabPanels.forEach(function (panel) {
          const active = panel.getAttribute('data-tab') === tab;
          panel.classList.toggle('ctab__panel--active', active);
          panel.hidden = !active;
          if (active) {
            const swiperElement = panel.querySelector('.ctab__swiper');
            if (swiperElement) {
              const sectionId = swiperElement.dataset.sectionId;
              const tabLabel = swiperElement.dataset.tab;
              const instanceKey = sectionId + '-' + tabLabel;

              let swiper = swiperInstances.get(instanceKey);
              if (!swiper) {
                initCtabSwiper(swiperElement, sectionId, tabLabel);
                swiper = swiperInstances.get(instanceKey);
              }

              if (swiper) {
                // Preserve slide position when returning to a tab
                swiper.update();
              }
            }
          }
        });
      }

      tabTriggers.forEach(function (triggerButton) {
        triggerButton.addEventListener('click', function () {
          const tab = triggerButton.getAttribute('data-tab');
          if (tab) switchTab(tab);
        });
      });

      initAllSwipers();

      section.querySelectorAll('.ctab__card-arrow--prev, .ctab__card-arrow--next').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          const card = button.closest('.ctab__card');
          if (card) card.classList.toggle('ctab__card--showing-secondary');
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-ctab-section]').forEach(initSection);
    }

    window.addEventListener('resize', updateNoHoverSwapAll);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      var section = document.querySelector('[data-ctab-section][data-section-id="' + sectionId + '"]');
      if (section) {
        setTimeout(function () {
          initSection(section);
          updateNoHoverSwapAll();
        }, 100);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cruiser-tech-features"] && !Shopify.designMode) return;
  try {
    
  function initializeTechSwiper() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initializeTechSwiper, 100);
      return;
    }

    var swiper = new Swiper('.technology-slider', {
      loop: true,
      spaceBetween: 5,
      slidesPerView: 1.1,
      navigation: {
        nextEl: '.technology-next-button',
        prevEl: '.technology-prev-button',
      },
      breakpoints: {
        640: {
          slidesPerView: 1.4,
        },
        768: {
          slidesPerView: 2,
        },
        990: {
          slidesPerView: 2.5,
        },
        1280: {
          slidesPerView: 3,
        },
      },
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTechSwiper);
  } else {
    initializeTechSwiper();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-announcementbar"] && !Shopify.designMode) return;
  try {
    
  window.discountCode = function (e) {
    var button = e.target.closest('button');
    var copyText = button.previousElementSibling;
    var discountTooltip = button.closest('.discount-tooltip');

    // Prefer modern clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(copyText.innerText)
        .then(() => {
          var tooltip = button.querySelector('#copyTooltip');
          tooltip.innerHTML = 'Copied: ' + copyText.innerText;
          discountTooltip.classList.add('copied');
        })
        .catch((err) => {
          console.error('Clipboard API failed: ', err);
        });
    } else {
      // Fallback for older browsers
      var textArea = document.createElement('textarea');
      textArea.value = copyText.innerText;

      // Prevent Safari scroll bug
      textArea.style.position = 'fixed';
      textArea.style.top = '0';
      textArea.style.left = '-9999px';

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        var tooltip = button.querySelector('#copyTooltip');
        tooltip.innerHTML = 'Copied: ' + copyText.innerText;
        discountTooltip.classList.add('copied');
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }

      document.body.removeChild(textArea);
    }
  };

  // Add mouse hover functionality to pause/resume marquee
  document.addEventListener('DOMContentLoaded', function () {
    const announcementWrappers = document.querySelectorAll('.alterego-announcement-wrapper');

    announcementWrappers.forEach((wrapper) => {
      const textWraps = wrapper.querySelectorAll('.alterego-announcement-text-wrap');

      wrapper.addEventListener('mouseenter', function () {
        textWraps.forEach((wrap) => {
          wrap.classList.add('paused');
        });
      });

      wrapper.addEventListener('mouseleave', function () {
        textWraps.forEach((wrap) => {
          wrap.classList.remove('paused');
        });
      });
    });
  });

  // sign-up-button
  document.addEventListener('DOMContentLoaded', function () {
    const signUpButton = document.querySelectorAll('.sign-up-button a[href="#sign-up"]');
    signUpButton.forEach((button) => {
      button.addEventListener('click', function () {
        const needsClick = document.querySelector('.needsclick[role="button"]');
        if (needsClick) {
          needsClick.click();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  class MobileMenu {
    constructor() {
      this.mobileMenu = document.querySelector('[data-mobile-menu]');
      this.menuTrigger = document.querySelector('[data-mobile-menu-trigger]');
      this.closeButton = document.querySelector('[data-mobile-menu-close]');
      this.submenuTriggers = document.querySelectorAll('[data-submenu-trigger]');
      this.submenuBackButtons = document.querySelectorAll('[data-submenu-back]');

      this.init();
    }

    init() {
      if (!this.mobileMenu) return;

      // Toggle mobile menu
      this.menuTrigger?.addEventListener('click', () => {
        this.mobileMenu.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      });

      this.closeButton?.addEventListener('click', () => {
        this.closeMenu();
      });

      // Handle submenus
      this.submenuTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          const submenuId = trigger.getAttribute('data-submenu-trigger');
          const submenu = document.querySelector(`[data-submenu="${submenuId}"]`);

          if (submenu) {
            submenu.classList.add('is-active');
          }
        });
      });

      this.submenuBackButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          const submenu = button.closest('.mobile-submenu');
          if (submenu) {
            submenu.classList.remove('is-active');
          }
        });
      });

      // Close menu on overlay click
      document.addEventListener('click', (e) => {
        if (e.target === this.mobileMenu) {
          this.closeMenu();
        }
      });
    }

    closeMenu() {
      this.mobileMenu.classList.remove('is-active');
      document.body.style.overflow = '';

      // Reset all submenus
      const activeSubmenus = this.mobileMenu.querySelectorAll('.mobile-submenu.is-active');
      activeSubmenus.forEach((submenu) => {
        submenu.classList.remove('is-active');
      });
    }
  }

  // Initialize mobile menu
  window.addEventListener('DOMContentLoaded', () => {
    new MobileMenu();
  });
  // Function to update cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const cartCounts = document.querySelectorAll('[data-cart-count]');
        cartCounts.forEach((count) => {
          count.textContent = cart.item_count;
          count.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch((error) => console.error('Error updating cart count:', error));
  }

  // Hide wishlist badge when 0, show when 1+
  function updateWishlistBadgeVisibility(el) {
    const count = parseInt(el.getAttribute('data-total') || el.textContent || '0', 10);
    el.style.display = count > 0 ? '' : 'none';
  }

  function initWishlistBadgeVisibility() {
    document.querySelectorAll('.wishlist-total-count[data-wishlist-count-badge]').forEach((el) => {
      updateWishlistBadgeVisibility(el);
      const obs = new MutationObserver(() => updateWishlistBadgeVisibility(el));
      obs.observe(el, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-total'],
      });
    });
  }

  // Listen for cart updates
  document.addEventListener('cart:updated', updateCartCount);
  document.addEventListener('cart:refresh', updateCartCount);

  // Also update when items are added/removed via ajax
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then((response) => {
      if (
        response.url.includes('/cart/add.js') ||
        response.url.includes('/cart/update.js') ||
        response.url.includes('/cart/change.js') ||
        response.url.includes('/cart/clear.js')
      ) {
        updateCartCount();
      }
      return response;
    });
  };

  // Initial cart count update and wishlist badge visibility
  document.addEventListener('DOMContentLoaded', () => {
    updateCartCount();
    initWishlistBadgeVisibility();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-logo-marquee-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var RESUME_DELAY_MS = 3000;

    function initMarquee(section) {
      var viewport = section.querySelector('.custom-logo-marquee__viewport');
      var track = section.querySelector('.custom-logo-marquee__track');
      if (!viewport || !track) return;

      var resumeTimeoutId = null;

      function pause() {
        track.classList.add('is-touch-paused');
        if (resumeTimeoutId) clearTimeout(resumeTimeoutId);
      }

      function resume() {
        track.classList.remove('is-touch-paused');
        resumeTimeoutId = null;
      }

      function onTap() {
        if (typeof window.matchMedia === 'function' && !window.matchMedia('(max-width: 749px)').matches) return;
        if (track.classList.contains('is-touch-paused') && resumeTimeoutId !== null) {
          if (resumeTimeoutId) clearTimeout(resumeTimeoutId);
          resume();
          return;
        }
        pause();
        resumeTimeoutId = setTimeout(resume, RESUME_DELAY_MS);
      }

      viewport.addEventListener('click', onTap);
      viewport.addEventListener('mouseover', pause, { passive: false });
      viewport.addEventListener('mouseleave', resume, { passive: false });
      viewport.addEventListener('mouseenter', resume, { passive: false });
      viewport.addEventListener('mouseup', resume, { passive: false });
      viewport.addEventListener('mousedown', pause, { passive: false });
      viewport.addEventListener('mouseout', resume, { passive: false });
    }

    document.querySelectorAll('[data-custom-logo-marquee]').forEach(initMarquee);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-your-fit"] && !Shopify.designMode) return;
  try {
    
  function initializeFitSwiper() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initializeFitSwiper, 100);
      return;
    }

    var fitThumbs = new Swiper('.fit-thumbs-slider', {
    autoplay: false,
    speed: 500,
    slidesPerView: 4,
    freeMode: false,
    loop: true,
    watchSlidesProgress: true,
    spaceBetween: 20,
    centeredSlides: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      475: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      550: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 6,
      },
      1280: {
        slidesPerView: 6,
      },
      1440: {
        slidesPerView: 6,
      },
    },
  });

  var fitSlider = new Swiper('.fit-slider', {
    autoplay: false,
    effect: 'fade',
    speed: 500,
    slidesPerView: 1,
    freeMode: false,
    loop: true,
    watchSlidesProgress: true,
    spaceBetween: 30,
    centeredSlides: false,
    thumbs: {
      swiper: fitThumbs,
    },
    navigation: {
      nextEl: '.fit-next-button',
      prevEl: '.fit-prev-button',
    },
  });

    fitThumbs.slides.forEach((slide, index) => {
      slide.addEventListener('mouseover', () => {
        fitSlider.slideToLoop(index);
      });
    });
  }

  initializeFitSwiper();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-alt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFooterAltAccordions() {
      const footer = document.querySelector('.footer-alt');
      if (!footer) return;

      footer.addEventListener('click', function (e) {
        const trigger = e.target.closest('[data-accordion-trigger]');
        if (!trigger) return;

        const accordion = trigger.closest('[data-accordion]');
        const panel = accordion?.querySelector('[data-accordion-panel]');
        if (!accordion || !panel) return;

        const isOpen = accordion.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFooterAltAccordions);
    } else {
      initFooterAltAccordions();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hat-fit-guide"] && !Shopify.designMode) return;
  try {
    
  function initializeHatFitSwiper() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initializeHatFitSwiper, 100);
      return;
    }

    var hatFitSliderThumbs = new Swiper('.custom-page-thumb-slider', {
      autoplay: false,
      freeMode: true,
      loop: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      spaceBetween: 10,
      centeredSlides: false,
      multipleActiveThumbs: false,
      breakpoints: {
        0: {
          slidesPerView: 1.5,
        },
        375: {
          slidesPerView: 2,
        },
        550: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 6,
        },
      },
    });

    var hatFitSlider = new Swiper('.custom-page-slider', {
      autoplay: false,
      speed: 500,
      slidesPerView: 2,
      freeMode: false,
      loop: true,
      watchSlidesProgress: true,
      spaceBetween: 30,
      centeredSlides: false,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1,
        },
      },
      thumbs: {
        swiper: hatFitSliderThumbs,
      },
    });

    const hatFitSliderWrapper = hatFitSlider.wrapperEl;

    [].forEach.call(hatFitSlider.slides, function (slide) {
      slide.style.height = '';
    });

    setTimeout(() => {
      [].forEach.call(hatFitSlider.slides, function (slide) {
        slide.style.height = hatFitSliderWrapper.clientHeight + 'px';
      });
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHatFitSwiper);
  } else {
    initializeHatFitSwiper();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hat-fits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initSection(section) {
      if (!section || !section.hasAttribute('data-hat-fits-section')) return;

      const swiperElement = section.querySelector('[data-hat-fits-swiper]');
      const prevButton = section.querySelector('[data-swiper-prev]');
      const nextButton = section.querySelector('[data-swiper-next]');
      const progressBar = section.querySelector('[data-progress-bar]');
      const progressBarFill = progressBar ? progressBar.querySelector('.hat-fits__progress-bar') : null;

      let swiperInstance = null;
      let wheelListenerAdded = false;
      let accumulatedWheelDelta = 0;
      let wheelRafId = null;
      let wheelSnapTimeout = null;

      function destroySwiper() {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }

      function initSwiper() {
        if (!swiperElement || typeof Swiper === 'undefined') {
          if (typeof Swiper === 'undefined') {
            setTimeout(initSwiper, 100);
          }
          return;
        }

        destroySwiper();

        const isMobile = window.innerWidth <= 767;
        const slidesPerView = isMobile ? 1 : 3.5;
        const spaceBetween = 8;

        swiperInstance = new Swiper(swiperElement, {
          slidesPerView: slidesPerView,
          spaceBetween: spaceBetween,
          loop: false,
          speed: 300,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          on: {
            init: function () {
              updateProgress(this);
              updateNavButtons(this);
              if (progressBar) setupProgressBarDrag(progressBar, this);
              if (!wheelListenerAdded && swiperElement) {
                wheelListenerAdded = true;
                swiperElement.addEventListener(
                  'wheel',
                  function (e) {
                    if (!swiperInstance || window.innerWidth <= 767) return;
                    const isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
                    if (!isHorizontal) return;
                    const rawDelta = -e.deltaX;
                    const sensitivity = 12;
                    accumulatedWheelDelta += rawDelta * sensitivity;
                    if (Math.abs(accumulatedWheelDelta) < 0.5) return;
                    e.preventDefault();
                    if (wheelRafId == null) {
                      wheelRafId = requestAnimationFrame(function applyWheelFrame() {
                        wheelRafId = null;
                        if (!swiperInstance || Math.abs(accumulatedWheelDelta) < 0.5) return;
                        if (wheelSnapTimeout) clearTimeout(wheelSnapTimeout);
                        const swiperMin =
                          typeof swiperInstance.minTranslate === 'function' ? swiperInstance.minTranslate() : 0;
                        const swiperMax =
                          typeof swiperInstance.maxTranslate === 'function' ? swiperInstance.maxTranslate() : 0;
                        const minT = Math.min(swiperMin, swiperMax);
                        const maxT = Math.max(swiperMin, swiperMax);
                        const t =
                          typeof swiperInstance.getTranslate === 'function'
                            ? swiperInstance.getTranslate()
                            : swiperInstance.translate;
                        const delta = accumulatedWheelDelta;
                        accumulatedWheelDelta = 0;
                        let newT = t + delta;
                        newT = Math.max(minT, Math.min(maxT, newT));
                        const progress = maxT !== minT ? (newT - maxT) / (minT - maxT) : 0;
                        if (typeof swiperInstance.setTransition === 'function') swiperInstance.setTransition(0);
                        swiperInstance.setTranslate(newT);
                        if (typeof swiperInstance.setTransition === 'function') swiperInstance.setTransition(300);
                        updateProgress(swiperInstance, progress);
                        updateNavButtons(swiperInstance);
                        wheelSnapTimeout = setTimeout(function () {
                          wheelSnapTimeout = null;
                          if (!swiperInstance) return;
                          const count = swiperInstance.slides.length;
                          if (count <= 1) return;
                          const currentT =
                            typeof swiperInstance.getTranslate === 'function'
                              ? swiperInstance.getTranslate()
                              : swiperInstance.translate;
                          var swiperMin =
                            typeof swiperInstance.minTranslate === 'function' ? swiperInstance.minTranslate() : 0;
                          var swiperMax =
                            typeof swiperInstance.maxTranslate === 'function' ? swiperInstance.maxTranslate() : 0;
                          var endTranslate = Math.min(swiperMin, swiperMax);
                          var activeIndex = 0;
                          if (currentT <= endTranslate + 10) {
                            activeIndex = count - 1;
                          } else {
                            var bestDist = Infinity;
                            for (var i = 0; i < count; i++) {
                              var slideOffset = swiperInstance.slides[i].offsetLeft;
                              var targetT = -slideOffset;
                              var dist = Math.abs(currentT - targetT);
                              if (dist < bestDist) {
                                bestDist = dist;
                                activeIndex = i;
                              }
                            }
                          }
                          if (activeIndex === count - 1) {
                            if (typeof swiperInstance.setTransition === 'function') swiperInstance.setTransition(300);
                            swiperInstance.setTranslate(endTranslate);
                          } else {
                            swiperInstance.slideTo(activeIndex, 300);
                          }
                          updateProgress(swiperInstance);
                          updateNavButtons(swiperInstance);
                        }, 150);
                      });
                    }
                  },
                  { passive: false },
                );
              }
            },
            slideChange: function () {
              updateProgress(this);
              updateNavButtons(this);
            },
            slideChangeTransitionEnd: function () {
              updateProgress(this);
              updateNavButtons(this);
            },
            resize: function () {
              const newIsMobile = window.innerWidth <= 767;
              this.params.slidesPerView = newIsMobile ? 1 : 3.5;
              this.update();
              updateProgress(this);
              updateNavButtons(this);
            },
          },
        });
      }

      function updateProgress(swiper, progressOverride) {
        if (!progressBarFill || !swiper) return;

        const totalSlides = swiper.slides.length;
        let scrollRatio;

        if (progressOverride !== undefined) {
          scrollRatio = progressOverride;
        } else if (totalSlides <= 1) {
          scrollRatio = 0;
        } else {
          const minT = typeof swiper.minTranslate === 'function' ? swiper.minTranslate() : 0;
          const maxT = typeof swiper.maxTranslate === 'function' ? swiper.maxTranslate() : 0;
          const translate = typeof swiper.getTranslate === 'function' ? swiper.getTranslate() : swiper.translate;
          var startTranslate = Math.max(minT, maxT);
          var endTranslate = Math.min(minT, maxT);
          var range = endTranslate - startTranslate;
          scrollRatio = range !== 0 ? (translate - startTranslate) / range : 0;
          scrollRatio = Math.min(1, Math.max(0, scrollRatio));
          if (swiper.isBeginning) scrollRatio = 0;
          if (swiper.isEnd) scrollRatio = 1;
        }

        const progress = totalSlides > 1 ? ((scrollRatio * (totalSlides - 1) + 1) / totalSlides) * 100 : 0;

        progressBarFill.style.width = '';
        const thumbWidthPercent = 20;
        const maxLeft = 100 - thumbWidthPercent;
        const leftPct = scrollRatio * maxLeft;
        progressBarFill.style.left = leftPct + '%';
        progressBarFill.classList.toggle('hat-fits__progress-bar--empty', progress <= 0);
      }

      function updateNavButtons(swiper) {
        if (!swiper) return;
        if (prevButton) {
          prevButton.disabled = swiper.isBeginning;
        }
        if (nextButton) {
          nextButton.disabled = swiper.isEnd;
        }
      }

      function setupProgressBarDrag(progressBarEl, swiper) {
        if (!progressBarEl || !swiper) return;

        if (progressBarEl._progressDragSetup) {
          progressBarEl._progressSwiper = swiper;
          return;
        }
        progressBarEl._progressDragSetup = true;
        progressBarEl._progressSwiper = swiper;

        function getTotalSlides() {
          return progressBarEl._progressSwiper ? progressBarEl._progressSwiper.slides.length : 0;
        }

        function getProgress(clientX) {
          const rect = progressBarEl.getBoundingClientRect();
          const progress = (clientX - rect.left) / rect.width;
          return Math.min(1, Math.max(0, progress));
        }

        function goToProgress(clientX) {
          const total = getTotalSlides();
          if (total <= 1) return;
          const progress = getProgress(clientX);
          const slideIndex = Math.min(total - 1, Math.max(0, Math.round(progress * (total - 1))));
          var swiper = progressBarEl._progressSwiper;
          if (slideIndex === total - 1) {
            var minT = typeof swiper.minTranslate === 'function' ? swiper.minTranslate() : 0;
            var maxT = typeof swiper.maxTranslate === 'function' ? swiper.maxTranslate() : 0;
            var endT = Math.min(minT, maxT);
            if (typeof swiper.setTransition === 'function') swiper.setTransition(300);
            swiper.setTranslate(endT);
          } else {
            swiper.slideTo(slideIndex, 300);
          }
          updateProgress(swiper);
          updateNavButtons(swiper);
        }

        let activePointerId = null;

        function onPointerMove(e) {
          if (e.pointerType === 'touch') e.preventDefault();
          goToProgress(e.clientX);
        }

        function endDrag(e) {
          if (activePointerId !== null && e.pointerId !== activePointerId) return;
          activePointerId = null;
          progressBarEl.classList.remove('is-dragging');
          try {
            progressBarEl.releasePointerCapture(e.pointerId);
          } catch (err) {}
          progressBarEl.removeEventListener('pointermove', onPointerMove);
          progressBarEl.removeEventListener('pointerup', endDrag);
          progressBarEl.removeEventListener('pointercancel', endDrag);
          progressBarEl.removeEventListener('pointerleave', onPointerLeave);
        }

        function onPointerLeave(e) {
          if (activePointerId !== null && e.pointerId === activePointerId) endDrag(e);
        }

        progressBarEl.addEventListener(
          'pointerdown',
          function (e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            if (e.cancelable) e.preventDefault();
            activePointerId = e.pointerId;
            progressBarEl.classList.add('is-dragging');
            goToProgress(e.clientX);
            progressBarEl.setPointerCapture(e.pointerId);
            progressBarEl.addEventListener('pointermove', onPointerMove, { passive: false });
            progressBarEl.addEventListener('pointerup', endDrag);
            progressBarEl.addEventListener('pointercancel', endDrag);
            progressBarEl.addEventListener('pointerleave', onPointerLeave);
          },
          { passive: false },
        );
      }

      function initOverlays() {
        const triggers = section.querySelectorAll('[data-overlay-trigger]');
        const overlays = section.querySelectorAll('[data-overlay]');
        const closeButtons = section.querySelectorAll('[data-overlay-close]');

        triggers.forEach(function (trigger) {
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const overlayId = trigger.getAttribute('data-overlay-trigger');
            const overlay = document.getElementById('overlay-' + overlayId);
            if (overlay) {
              overlay.classList.add('active');
            }
          });
        });

        closeButtons.forEach(function (closeBtn) {
          closeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const overlayId = closeBtn.getAttribute('data-overlay-close');
            const overlay = document.getElementById('overlay-' + overlayId);
            if (overlay) {
              overlay.classList.remove('active');
            }
          });
        });

        overlays.forEach(function (overlay) {
          overlay.addEventListener('click', function (e) {
            if (e.target === overlay) {
              overlay.classList.remove('active');
            }
          });
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            overlays.forEach(function (overlay) {
              if (overlay.classList.contains('active')) {
                overlay.classList.remove('active');
              }
            });
          }
        });
      }

      function applySegmentTracks() {
        const shapeFeaturesContainers = section.querySelectorAll('.hat-fits__shape-features');
        shapeFeaturesContainers.forEach(function (container) {
          const features = container.querySelectorAll('.hat-shape-feature');
          features.forEach(function (feature) {
            const track = feature.querySelector('.hat-shape-feature__slider-track');
            const indicator = feature.querySelector('.hat-shape-feature__slider-indicator');
            if (!track) return;
            const labels = feature.querySelectorAll('.hat-shape-feature__slider-label');
            const labelCount = labels.length;
            if (labelCount === 3) {
              var positionPct = 50;
              if (track.style.width) {
                var widthNum = parseFloat(track.style.width, 10);
                if (widthNum <= 33) positionPct = 16.667;
                else if (widthNum >= 67) positionPct = 83.333;
                else positionPct = 50;
              }
              track.style.width = '33.333%';
              track.style.left = positionPct + '%';
              track.style.transform = 'translateX(-50%)';
            } else if (labelCount === 2) {
              track.style.width = '50%';
              var centerPct = 25;
              if (indicator && indicator.style.left) {
                var indicatorLeft = parseFloat(indicator.style.left, 10);
                centerPct = indicatorLeft >= 50 ? 75 : 25;
              }
              track.style.left = centerPct + '%';
              track.style.transform = 'translateX(-50%)';
            }
          });
        });
      }

      initSwiper();
      initOverlays();
      applySegmentTracks();
    }

    function initAll() {
      document.querySelectorAll('[data-hat-fits-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      const section = document.querySelector('[data-hat-fits-section][data-section-id="' + e.detail.sectionId + '"]');
      if (section) {
        initSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeroBannerVideos = () => {
      document.querySelectorAll('[data-hero-banner-video]').forEach((wrap) => {
        const video = wrap.querySelector('.hero-banner__video');
        const poster = wrap.querySelector('.hero-banner__video-poster');
        if (!video || wrap.dataset.heroVideoInit === '1') return;

        wrap.dataset.heroVideoInit = '1';
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');

        const startPlayback = () => {
          wrap.classList.add('hero-banner__video-wrap--playing');
          if (poster) poster.setAttribute('aria-hidden', 'true');
          video.play().catch(() => {});
        };

        let started = false;
        let fallbackId = null;
        const clearFallback = () => {
          if (fallbackId) {
            clearTimeout(fallbackId);
            fallbackId = null;
          }
        };
        const tryStart = () => {
          clearFallback();
          if (started) return;
          started = true;
          startPlayback();
        };

        const onCanPlayThrough = () => {
          video.removeEventListener('canplaythrough', onCanPlayThrough);
          video.removeEventListener('loadeddata', onLoadedData);
          video.removeEventListener('loadedmetadata', onLoadedMetadata);
          tryStart();
        };

        const onLoadedData = () => {
          if (video.readyState >= 4) {
            video.removeEventListener('canplaythrough', onCanPlayThrough);
            video.removeEventListener('loadeddata', onLoadedData);
            video.removeEventListener('loadedmetadata', onLoadedMetadata);
            tryStart();
          }
        };

        const onLoadedMetadata = () => {
          if (video.readyState >= 4) {
            video.removeEventListener('canplaythrough', onCanPlayThrough);
            video.removeEventListener('loadeddata', onLoadedData);
            video.removeEventListener('loadedmetadata', onLoadedMetadata);
            tryStart();
          }
        };

        const attachListeners = () => {
          if (video.readyState >= 4) {
            tryStart();
            return;
          }
          video.addEventListener('canplaythrough', onCanPlayThrough);
          video.addEventListener('loadeddata', onLoadedData);
          video.addEventListener('loadedmetadata', onLoadedMetadata);
          fallbackId = setTimeout(() => {
            video.removeEventListener('canplaythrough', onCanPlayThrough);
            video.removeEventListener('loadeddata', onLoadedData);
            video.removeEventListener('loadedmetadata', onLoadedMetadata);
            video.load();
            tryStart();
          }, 4000);
        };

        const observer = new IntersectionObserver(
          (entries) => {
            const e = entries[0];
            if (!e?.isIntersecting) return;
            observer.disconnect();
            video.load();
            attachListeners();
          },
          { rootMargin: '0px', threshold: 0.1 },
        );
        observer.observe(wrap);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroBannerVideos);
    } else {
      initHeroBannerVideos();
    }

    document.addEventListener('shopify:section:load', initHeroBannerVideos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var RESUME_DELAY_MS = 3000;

    function initMarquee(section) {
      var viewport = section.querySelector('.marquee-strip__viewport');
      var track = section.querySelector('.marquee-strip__track');
      if (!viewport || !track) return;

      var resumeTimeoutId = null;

      function pause() {
        track.classList.add('is-touch-paused');
        if (resumeTimeoutId) clearTimeout(resumeTimeoutId);
      }

      function resume() {
        track.classList.remove('is-touch-paused');
        resumeTimeoutId = null;
      }

      function onTap() {
        if (typeof window.matchMedia === 'function' && !window.matchMedia('(max-width: 749px)').matches) return;
        if (track.classList.contains('is-touch-paused') && resumeTimeoutId !== null) {
          if (resumeTimeoutId) clearTimeout(resumeTimeoutId);
          resume();
          return;
        }
        pause();
        resumeTimeoutId = setTimeout(resume, RESUME_DELAY_MS);
      }

      viewport.addEventListener('click', onTap);
    }
    document.querySelectorAll('[data-marquee-strip]').forEach(initMarquee);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-showcase-cms-pages"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const colorwayDataCache = new Map();

    function initSection(section) {
      if (!section || !section.hasAttribute('data-product-collection-showcase-section')) return;

      const collectionHandleValue = section.dataset.collectionHandle || '';
      if (!collectionHandleValue) return;

      const productLimit = parseInt(section.dataset.productLimit, 10) || 4;
      const showBadge = section.dataset.showBadge !== 'false';

      const mainSwiperElement = section.querySelector('[data-product-collection-swiper]');
      const productWrapperElement = section.querySelector('[data-product-wrapper]');
      const paginationEl = section.querySelector('.product-collection-showcase__pagination-wrap .swiper-pagination');
      const progressBar = section.querySelector('[data-progress-bar]');
      const progressBarFill = progressBar
        ? progressBar.querySelector('.product-collection-showcase__progress-bar')
        : null;
      let mainSwiperInstance = null;
      let resizeDebounceTimer = null;
      let wheelListenerAdded = false;
      let isWheelScrolling = false;
      let accumulatedWheelDelta = 0;
      let wheelRafId = null;

      const updateProgressBar = (swiper, progressOverride) => {
        if (!progressBarFill || !swiper) return;
        if (isWheelScrolling && progressOverride === undefined) return;
        const thumbWidthPercent = 20;
        const maxLeft = 100 - thumbWidthPercent;
        const progress =
          progressOverride !== undefined
            ? Math.min(1, Math.max(0, progressOverride))
            : Math.min(1, Math.max(0, swiper.progress));
        const leftPct = progress * maxLeft;
        progressBarFill.style.left = leftPct + '%';
      };

      const setupProgressBarDrag = (progressBarEl, swiper) => {
        if (!progressBarEl || !swiper) return;
        if (progressBarEl._progressDragSetup) {
          progressBarEl._progressSwiper = swiper;
          return;
        }
        progressBarEl._progressDragSetup = true;
        progressBarEl._progressSwiper = swiper;

        function getProgress(clientX) {
          const rect = progressBarEl.getBoundingClientRect();
          const progress = (clientX - rect.left) / rect.width;
          return Math.min(1, Math.max(0, progress));
        }

        function goToProgress(clientX) {
          const total = progressBarEl._progressSwiper ? progressBarEl._progressSwiper.slides.length : 0;
          if (total <= 1) return;
          const slideIndex = Math.min(total - 1, Math.max(0, Math.round(getProgress(clientX) * (total - 1))));
          progressBarEl._progressSwiper.slideTo(slideIndex);
          updateProgressBar(progressBarEl._progressSwiper);
        }

        let activePointerId = null;

        function onPointerMove(e) {
          if (e.pointerType === 'touch') e.preventDefault();
          goToProgress(e.clientX);
        }

        function endDrag(e) {
          if (activePointerId !== null && e.pointerId !== activePointerId) return;
          activePointerId = null;
          progressBarEl.classList.remove('is-dragging');
          try {
            progressBarEl.releasePointerCapture(e.pointerId);
          } catch (err) {}
          progressBarEl.removeEventListener('pointermove', onPointerMove);
          progressBarEl.removeEventListener('pointerup', endDrag);
          progressBarEl.removeEventListener('pointercancel', endDrag);
          progressBarEl.removeEventListener('pointerleave', onPointerLeave);
        }

        function onPointerLeave(e) {
          if (activePointerId !== null && e.pointerId === activePointerId) endDrag(e);
        }

        progressBarEl.addEventListener(
          'pointerdown',
          function (e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            if (e.cancelable) e.preventDefault();
            activePointerId = e.pointerId;
            progressBarEl.classList.add('is-dragging');
            goToProgress(e.clientX);
            progressBarEl.setPointerCapture(e.pointerId);
            progressBarEl.addEventListener('pointermove', onPointerMove, { passive: false });
            progressBarEl.addEventListener('pointerup', endDrag);
            progressBarEl.addEventListener('pointercancel', endDrag);
            progressBarEl.addEventListener('pointerleave', onPointerLeave);
          },
          { passive: false },
        );
      };

      const flattenGraphQLConnections = (graphQLObject) => {
        if (!(graphQLObject && typeof graphQLObject === 'object') || Array.isArray(graphQLObject)) return graphQLObject;
        if ('edges' in graphQLObject && Array.isArray(graphQLObject.edges)) {
          return graphQLObject.edges.map((edgeItem) => flattenGraphQLConnections(edgeItem.node));
        }
        for (const propertyName in graphQLObject)
          graphQLObject[propertyName] = flattenGraphQLConnections(graphQLObject[propertyName]);
        return graphQLObject;
      };

      const fetchCollectionProducts = async () => {
        try {
          const countryCode = section.dataset.countryCode || null;
          const apiResponse = await fetch('/api/2024-07/graphql.json', {
            method: 'POST',
            headers: {
              'content-type': 'application/json',
              'x-shopify-storefront-access-token': '9f39520505c5a1a7f0bab22fb8a87abf',
            },
            body: JSON.stringify({
              query: countryCode
                ? `
              query getCollectionProducts($handle: String!, $first: Int!, $country: CountryCode!) @inContext(country: $country) {
                collection(handle: $handle) {
                  products(first: $first) {
                    edges {
                      node {
                        id
                        handle
                        title
                        tags
                        options { name values }
                        priceRange {
                          minVariantPrice { amount currencyCode }
                        }
                        compareAtPriceRange {
                          minVariantPrice { amount currencyCode }
                        }
                        images(first: 10) {
                          edges {
                            node {
                              url(transform: {maxWidth: 600, maxHeight: 800})
                              width height altText
                            }
                          }
                        }
                        variants(first: 250) {
                          edges {
                            node {
                              id title availableForSale
                              price { amount currencyCode }
                              image {
                                url(transform: {maxWidth: 100, maxHeight: 100})
                                width height
                              }
                              selectedOptions { name value }
                              metafield(namespace: "custom", key: "swatch_image") { value }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            `
                : `
              query getCollectionProducts($handle: String!, $first: Int!) {
                collection(handle: $handle) {
                  products(first: $first) {
                    edges {
                      node {
                        id
                        handle
                        title
                        tags
                        options { name values }
                        priceRange {
                          minVariantPrice { amount currencyCode }
                        }
                        compareAtPriceRange {
                          minVariantPrice { amount currencyCode }
                        }
                        images(first: 10) {
                          edges {
                            node {
                              url(transform: {maxWidth: 600, maxHeight: 800})
                              width height altText
                            }
                          }
                        }
                        variants(first: 250) {
                          edges {
                            node {
                              id title availableForSale
                              price { amount currencyCode }
                              image {
                                url(transform: {maxWidth: 100, maxHeight: 100})
                                width height
                              }
                              selectedOptions { name value }
                              metafield(namespace: "custom", key: "swatch_image") { value }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            `,
              variables: countryCode
                ? { handle: collectionHandleValue, first: productLimit, country: countryCode }
                : { handle: collectionHandleValue, first: productLimit },
            }),
          });

          const responseData = await apiResponse.json();
          if (!responseData?.data?.collection?.products) {
            return [];
          }

          const flattenedProducts = flattenGraphQLConnections(responseData.data.collection.products);
          return flattenedProducts.slice(0, productLimit);
        } catch (error) {
          return [];
        }
      };

      const validateImageUrl = (imageUrl) => {
        if (!imageUrl) return Promise.resolve(false);
        const timeoutMs = 4000;
        return (async () => {
          try {
            const c = new AbortController();
            const t = setTimeout(() => c.abort(), timeoutMs);
            const res = await fetch(imageUrl, { method: 'GET', signal: c.signal, credentials: 'omit' });
            clearTimeout(t);
            if (res.status === 404) return false;
            if (!res.ok) return false;
            const ct = (res.headers.get('Content-Type') || '').toLowerCase();
            if (ct && !ct.startsWith('image/')) return false;
            return true;
          } catch (e) {
            try {
              return await new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(true);
                img.onerror = () => resolve(false);
                img.src = imageUrl;
                setTimeout(() => resolve(false), timeoutMs);
              });
            } catch (err) {
              return false;
            }
          }
        })();
      };

      const extractSwatchImageFromVariant = (variantData) => {
        if (!variantData) return null;

        let swatchImageValue = null;

        if (variantData.metafield) {
          if (variantData.metafield.value !== null && variantData.metafield.value !== undefined) {
            swatchImageValue = variantData.metafield.value;
          } else if (typeof variantData.metafield === 'string') {
            swatchImageValue = variantData.metafield;
          }
        } else if (variantData.metafields && variantData.metafields.swatch_image) {
          swatchImageValue = variantData.metafields.swatch_image;
        }

        if (swatchImageValue !== null && swatchImageValue !== undefined) {
          const trimmedSwatchValue = String(swatchImageValue).trim();
          if (
            trimmedSwatchValue &&
            trimmedSwatchValue.length > 0 &&
            trimmedSwatchValue !== 'null' &&
            trimmedSwatchValue !== 'undefined' &&
            trimmedSwatchValue !== '' &&
            (trimmedSwatchValue.startsWith('http://') || trimmedSwatchValue.startsWith('https://'))
          ) {
            return trimmedSwatchValue;
          }
        }
        return null;
      };

      const isStandardVariant = (variant) => {
        if (!variant) return false;
        const titleDowncase = (variant.title || '').toLowerCase();
        if (titleDowncase.includes('standard')) return true;
        const options = variant.selectedOptions || [];
        for (let i = 0; i < options.length; i++) {
          if ((options[i].value || '').toLowerCase() === 'standard') return true;
        }
        return false;
      };

      const getVariantSwatchOrder = (variants) => {
        if (!variants || !variants.length) return [];
        const standard = variants.find(isStandardVariant);
        if (standard) {
          const rest = variants.filter((v) => v !== standard);
          return [standard, ...rest];
        }
        return [...variants];
      };

      const getFirstValidSwatchUrl = async (colorwayProductItem) => {
        const variants = colorwayProductItem.variants || [];
        const ordered = getVariantSwatchOrder(variants);
        for (const variant of ordered) {
          const metafieldUrl = extractSwatchImageFromVariant(variant);
          if (metafieldUrl && (await validateImageUrl(metafieldUrl))) return metafieldUrl;
        }
        for (const variant of ordered) {
          if (variant?.image?.url && (await validateImageUrl(variant.image.url))) return variant.image.url;
        }
        return null;
      };

      const extractColorTagFromProduct = (productData) => {
        if (!productData.tags || !Array.isArray(productData.tags)) return null;

        for (const productTag of productData.tags) {
          if (productTag.includes('_') && productTag !== 'new_arrival' && productTag !== 'Endless_Summer') {
            return productTag;
          }
        }
        return null;
      };

      const fetchColorwayProductsByTag = async (colorTag) => {
        if (colorwayDataCache.has(colorTag)) {
          return colorwayDataCache.get(colorTag);
        }

        try {
          const colorwayApiResponse = await fetch('/api/2024-07/graphql.json', {
            method: 'POST',
            headers: {
              'content-type': 'application/json',
              'x-shopify-storefront-access-token': '9f39520505c5a1a7f0bab22fb8a87abf',
            },
            body: JSON.stringify({
              query: `
              query getProductsByTag($query: String!) {
                colorways: products(query: $query, first: 50) {
                  edges {
                    node {
                      handle
                      title
                      images(first: 2) {
                        edges {
                          node {
                            width
                            height
                            url(transform: {maxHeight: 100, maxWidth: 100})
                          }
                        }
                      }
                      variants(first: 250) {
                        edges {
                          node {
                            title
                            availableForSale
                            image {
                              url(transform: {maxHeight: 100, maxWidth: 100})
                              width
                              height
                            }
                            selectedOptions {
                              name
                              value
                            }
                            metafield(namespace: "custom", key: "swatch_image") {
                              value
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            `,
              variables: { query: `tag:${colorTag}` },
            }),
          });

          const colorwayResponseData = await colorwayApiResponse.json();
          const flattenedColorwayProducts = flattenGraphQLConnections(colorwayResponseData?.data?.colorways || []);

          colorwayDataCache.set(colorTag, flattenedColorwayProducts);
          return flattenedColorwayProducts;
        } catch (error) {
          return [];
        }
      };

      const getProductColorOptions = async (productData) => {
        try {
          const productColorTag = extractColorTagFromProduct(productData);
          if (!productColorTag) return [];

          const colorwayProductsList = await fetchColorwayProductsByTag(productColorTag);
          if (colorwayProductsList.length === 0) return [];

          const uniqueColorOptionsMap = new Map();

          const colorwayProcessingPromises = colorwayProductsList.map(async (colorwayProductItem) => {
            let fallbackImageUrl = null;
            if (colorwayProductItem.variants?.length) {
              const v = colorwayProductItem.variants.find((x) => x.image?.url);
              fallbackImageUrl = v?.image?.url || colorwayProductItem.variants[0]?.image?.url;
            }
            if (!fallbackImageUrl && colorwayProductItem.images?.[0]?.url) {
              fallbackImageUrl = colorwayProductItem.images[0].url;
            }

            const swatchImageUrl = await getFirstValidSwatchUrl(colorwayProductItem);
            const finalImage = swatchImageUrl || fallbackImageUrl;
            const finalFallback = fallbackImageUrl || finalImage;

            return {
              name: colorwayProductItem.title,
              handle: colorwayProductItem.handle,
              image: finalImage,
              fallback: finalFallback,
              available: colorwayProductItem.variants?.some((variantItem) => variantItem.availableForSale) || false,
            };
          });

          const processedColorOptions = await Promise.all(colorwayProcessingPromises);

          processedColorOptions.forEach((colorOption) => {
            if (!uniqueColorOptionsMap.has(colorOption.handle)) {
              uniqueColorOptionsMap.set(colorOption.handle, colorOption);
            }
          });

          return Array.from(uniqueColorOptionsMap.values());
        } catch (error) {
          return [];
        }
      };

      const formatProductPrice = (priceAmount, currencyCodeValue) => {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currencyCodeValue || 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(parseFloat(priceAmount));
      };

      const renderProductCardHTML = async (productData, colorOptionsList = []) => {
        if (typeof window.renderProductShowcaseCard === 'function') {
          const productCardHTML = window.renderProductShowcaseCard(
            productData,
            colorOptionsList,
            'product-collection-showcase',
            showBadge,
            true,
          );
          return `<div class="swiper-slide">${productCardHTML}</div>`;
        }

        return '';
      };

      const initializeProductImageSwipers = () => {
        section.querySelectorAll('[data-product-image-swiper]').forEach((imageSwiperElement) => {
          if (imageSwiperElement.dataset.initialized === 'true') return;
          imageSwiperElement.dataset.initialized = 'true';

          if (typeof Swiper === 'undefined') {
            setTimeout(() => initializeProductImageSwipers(), 100);
            return;
          }

          const productCardElement = imageSwiperElement.closest('.product-collection-showcase__card');
          const previousButton = productCardElement?.querySelector(
            '.product-collection-showcase__card-image-arrow--prev',
          );
          const nextButton = productCardElement?.querySelector('.product-collection-showcase__card-image-arrow--next');

          const productImageSwiper = new Swiper(imageSwiperElement, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            allowTouchMove: true,
            navigation: {
              prevEl: previousButton,
              nextEl: nextButton,
            },
          });
        });
      };

      const getSlidesPerView = () => {
        const windowWidth = window.innerWidth;
        if (windowWidth <= 749) {
          return 1.6;
        } else if (windowWidth <= 1023) {
          return 3;
        } else {
          return 4;
        }
      };

      const initializeMainSwiper = () => {
        if (!mainSwiperElement || typeof Swiper === 'undefined') {
          if (typeof Swiper === 'undefined') {
            setTimeout(() => initializeMainSwiper(), 100);
          }
          return;
        }

        if (mainSwiperInstance) {
          mainSwiperInstance.destroy(true, true);
          mainSwiperInstance = null;
        }

        const slidesPerViewCount = getSlidesPerView();
        const spaceBetweenSlides = 0;

        mainSwiperInstance = new Swiper(mainSwiperElement, {
          slidesPerView: slidesPerViewCount,
          spaceBetween: spaceBetweenSlides,
          slidesPerGroup: 1,
          freeMode: false,
          grabCursor: true,
          width: null,
          autoHeight: false,
          resistance: true,
          resistanceRatio: 0.85,
          speed: 300,
          loop: false,
          allowTouchMove: true,
          pagination: paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : false,
          on: {
            init: function () {
              initializeProductImageSwipers();
              updateProgressBar(this);
              if (progressBar) setupProgressBarDrag(progressBar, this);
              if (!wheelListenerAdded && mainSwiperElement) {
                wheelListenerAdded = true;
                mainSwiperElement.addEventListener(
                  'wheel',
                  function (e) {
                    if (!mainSwiperInstance) return;
                    const isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
                    if (!isHorizontal) return;
                    const rawDelta = -e.deltaX;
                    const sensitivity = 18;
                    accumulatedWheelDelta += rawDelta * sensitivity;
                    if (Math.abs(accumulatedWheelDelta) < 0.5) return;
                    e.preventDefault();
                    isWheelScrolling = true;
                    if (wheelRafId == null) {
                      wheelRafId = requestAnimationFrame(function applyWheelFrame() {
                        wheelRafId = null;
                        if (!mainSwiperInstance || Math.abs(accumulatedWheelDelta) < 0.5) {
                          isWheelScrolling = false;
                          return;
                        }
                        const swiperMin = mainSwiperInstance.minTranslate();
                        const swiperMax = mainSwiperInstance.maxTranslate();
                        const minT = Math.min(swiperMin, swiperMax);
                        const maxT = Math.max(swiperMin, swiperMax);
                        const t =
                          typeof mainSwiperInstance.getTranslate === 'function'
                            ? mainSwiperInstance.getTranslate()
                            : mainSwiperInstance.translate;
                        const delta = accumulatedWheelDelta;
                        accumulatedWheelDelta = 0;
                        let newT = t + delta;
                        newT = Math.max(minT, Math.min(maxT, newT));
                        const progress = maxT !== minT ? (newT - maxT) / (minT - maxT) : 0;
                        if (typeof mainSwiperInstance.setTransition === 'function') {
                          mainSwiperInstance.setTransition(0);
                        }
                        mainSwiperInstance.setTranslate(newT);
                        if (typeof mainSwiperInstance.setTransition === 'function') {
                          mainSwiperInstance.setTransition(300);
                        }
                        updateProgressBar(mainSwiperInstance, progress);
                        isWheelScrolling = false;
                      });
                    }
                  },
                  { passive: false },
                );
              }
            },
            slideChange: function () {
              updateProgressBar(this);
            },
            progress: function () {
              updateProgressBar(this);
            },
            resize: function () {
              if (resizeDebounceTimer) clearTimeout(resizeDebounceTimer);
              resizeDebounceTimer = setTimeout(() => {
                this.params.slidesPerView = getSlidesPerView();
                this.update();
                updateProgressBar(this);
              }, 150);
            },
          },
        });
      };

      const loadAndRenderProducts = async () => {
        try {
          const fetchedProducts = await fetchCollectionProducts();
          if (fetchedProducts.length === 0) {
            const skeletonElements = productWrapperElement.querySelectorAll('[data-skeleton]');
            skeletonElements.forEach((skeletonElement) => skeletonElement.remove());
            section.classList.remove('product-collection-showcase--many-products');
            return;
          }

          const colorTagToProductsMap = new Map();
          fetchedProducts.forEach((productItem) => {
            const productColorTag = extractColorTagFromProduct(productItem);
            if (productColorTag && !colorTagToProductsMap.has(productColorTag)) {
              colorTagToProductsMap.set(productColorTag, []);
            }
            if (productColorTag) {
              colorTagToProductsMap.get(productColorTag).push(productItem);
            }
          });

          const colorwayFetchPromises = Array.from(colorTagToProductsMap.keys()).map((colorTag) =>
            fetchColorwayProductsByTag(colorTag),
          );
          await Promise.all(colorwayFetchPromises);

          const colorOptionsFetchPromises = fetchedProducts.map((productItem) => getProductColorOptions(productItem));
          const allProductColorOptions = await Promise.all(colorOptionsFetchPromises);

          let functionCheckRetries = 0;
          while (typeof window.renderProductShowcaseCard !== 'function' && functionCheckRetries < 10) {
            await new Promise((resolve) => setTimeout(resolve, 100));
            functionCheckRetries++;
          }

          if (typeof window.renderProductShowcaseCard !== 'function') {
            const skeletonElements = productWrapperElement.querySelectorAll('[data-skeleton]');
            skeletonElements.forEach((skeletonElement) => skeletonElement.remove());
            section.classList.remove('product-collection-showcase--many-products');
            return;
          }

          const productCardRenderPromises = fetchedProducts.map((productItem, productIndex) =>
            renderProductCardHTML(productItem, allProductColorOptions[productIndex]),
          );
          const renderedCardHTMLs = await Promise.all(productCardRenderPromises);

          const skeletonElements = productWrapperElement.querySelectorAll('[data-skeleton]');
          skeletonElements.forEach((skeletonElement) => skeletonElement.remove());

          productWrapperElement.innerHTML = renderedCardHTMLs.join('');

          /* Toggle pagination visibility on desktop: hide when 4 or fewer products */
          section.classList.toggle('product-collection-showcase--many-products', fetchedProducts.length > 4);

          setTimeout(() => {
            if (typeof window.initCardSkeletons === 'function') {
              window.initCardSkeletons();
            }
          }, 50);

          initializeMainSwiper();

          setTimeout(() => {
            if (mainSwiperInstance) {
              mainSwiperInstance.update();
            }
            initializeProductImageSwipers();
          }, 100);

          const productDataLoadPromises = fetchedProducts.map((productItem) =>
            loadProductAdditionalData(productItem.handle),
          );
          await Promise.all(productDataLoadPromises);

          setTimeout(() => {
            fetchedProducts.forEach((productItem) => {
              const productCardElement = section.querySelector(
                '.product-collection-showcase__card[data-product-handle="' + productItem.handle + '"]',
              );
              if (productCardElement && productCardElement.getAttribute('data-loading') === 'true') {
                const cardImageWrapper = productCardElement.querySelector(
                  '.product-collection-showcase__card-image-wrapper',
                );
                const firstProductImage = cardImageWrapper?.querySelector('img');
                if (firstProductImage && firstProductImage.complete && firstProductImage.naturalHeight > 0) {
                  productCardElement.setAttribute('data-loading', 'false');
                }
              }
            });
          }, 500);
        } catch (error) {
          const skeletonElements = productWrapperElement.querySelectorAll('[data-skeleton]');
          skeletonElements.forEach((skeletonElement) => skeletonElement.remove());
          section.classList.remove('product-collection-showcase--many-products');
        }
      };

      const loadProductAdditionalData = async (productHandleValue) => {
        try {
          const productDataUrl = `/products/${productHandleValue}?view=review`;
          const productDataResponse = await fetch(productDataUrl);
          const productDataHTML = await productDataResponse.text();
          const temporaryDiv = document.createElement('div');
          temporaryDiv.innerHTML = productDataHTML;

          const customDisplayTextElement = temporaryDiv.querySelector('.custom_display_text');
          const customTitleContainer = section.querySelector(
            `.product-collection-showcase__card[data-product-handle="${productHandleValue}"] .product-collection-showcase__card-custom-title`,
          );

          if (customDisplayTextElement && customTitleContainer) {
            const clonedTextElement = customDisplayTextElement.cloneNode(true);
            if (clonedTextElement.textContent) {
              if (typeof theme !== 'undefined' && theme.utils && theme.utils.toProperCase) {
                clonedTextElement.textContent = theme.utils.toProperCase(clonedTextElement.textContent);
              }
            }
            customTitleContainer.innerHTML = clonedTextElement.outerHTML;
          }

          const reviewBadgeElement = temporaryDiv.querySelector('.jdgm-preview-badge');
          const reviewContainerElement = section.querySelector(
            `.product-collection-showcase__card[data-product-handle="${productHandleValue}"] .product-collection-showcase__card-review`,
          );

          if (reviewBadgeElement && reviewContainerElement) {
            const previousBadgeElement = reviewBadgeElement.querySelector('.jdgm-prev-badge');
            const totalReviewCount = previousBadgeElement
              ? parseInt(previousBadgeElement.getAttribute('data-number-of-reviews') || '0', 10)
              : 0;

            if (totalReviewCount > 0) {
              reviewContainerElement.innerHTML = reviewBadgeElement.outerHTML;

              const reviewBadgeTextElement = reviewContainerElement.querySelector('.jdgm-prev-badge__text');
              if (reviewBadgeTextElement) {
                const reviewText = reviewBadgeTextElement.textContent.trim();
                const reviewCountMatch = reviewText.match(/(\d+)\s+review(s)?/i);
                if (reviewCountMatch) {
                  const reviewNumber = reviewCountMatch[1];
                  reviewBadgeTextElement.textContent = `(${reviewNumber})`;
                }
              }

              if (typeof window.jdgm !== 'undefined' && window.jdgm.loadWidgets) {
                window.jdgm.loadWidgets();
              }
            } else {
              const reviewWrapperElement = reviewContainerElement?.closest(
                '.product-collection-showcase__card-review-wrapper',
              );
              if (reviewWrapperElement) {
                reviewWrapperElement.style.display = 'none';
              }
            }
          }
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        } catch (error) {}
      };

      const handleProductCardClick = (clickEvent) => {
        const addToCartButton = clickEvent.target.closest('.product-collection-showcase__card-add-to-cart');
        const wishlistButton = clickEvent.target.closest(
          '.product-collection-showcase__card-wishlist, .wishlist-engine, .wishlist-engine-button',
        );
        const imageArrow = clickEvent.target.closest('.product-collection-showcase__card-image-arrow');
        const colorSwatch = clickEvent.target.closest('.product-collection-showcase__card-color-swatch');
        const productCard = clickEvent.target.closest('.product-collection-showcase__card');

        if (addToCartButton || wishlistButton || imageArrow || colorSwatch) {
          return;
        }

        if (productCard) {
          const productHandle = productCard.getAttribute('data-product-handle');
          if (productHandle) {
            window.location.href = `/products/${productHandle}`;
          }
        }
      };

      section.addEventListener('click', (clickEvent) => {
        const addToCartButton = clickEvent.target.closest('.product-collection-showcase__card-add-to-cart');
        if (!addToCartButton || addToCartButton.disabled) return;

        clickEvent.preventDefault();
        clickEvent.stopPropagation();
        clickEvent.stopImmediatePropagation();

        const productHandleValue = addToCartButton.dataset.productHandle;
        const productIdValue = addToCartButton.getAttribute('data-product-id');

        if (!productHandleValue) return;

        if (typeof window.openQuickAddModalProductCards === 'function') {
          window.openQuickAddModalProductCards(productHandleValue, productIdValue);
        } else {
          window.location.href = '/products/' + productHandleValue;
        }
      });

      section.addEventListener('click', handleProductCardClick);

      let sizeGuideModalCloseHandlers = {
        overlayClick: null,
        escapeKey: null,
      };

      const closeSizeGuideModal = () => {
        const toolTipElement = document.getElementById('ProductCollectionSizeGuide-' + section.dataset.sectionId);

        if (!toolTipElement) {
          return;
        }

        toolTipElement.removeAttribute('data-tool-tip-open');

        if (window.theme && window.theme.a11y && window.theme.a11y.unlockMobileScrolling) {
          window.theme.a11y.unlockMobileScrolling();
        }
        document.documentElement.classList.remove('modal-open');
        document.documentElement.classList.remove('lock-scroll');
        document.body.classList.remove('overflow-hidden');

        if (sizeGuideModalCloseHandlers.overlayClick) {
          document.removeEventListener('click', sizeGuideModalCloseHandlers.overlayClick);
          sizeGuideModalCloseHandlers.overlayClick = null;
        }

        if (sizeGuideModalCloseHandlers.escapeKey) {
          document.removeEventListener('keydown', sizeGuideModalCloseHandlers.escapeKey);
          sizeGuideModalCloseHandlers.escapeKey = null;
        }
      };

      const showSizeGuideModal = (modalType) => {
        const toolTipElement = document.getElementById('ProductCollectionSizeGuide-' + section.dataset.sectionId);

        if (!toolTipElement) {
          return;
        }

        const toolTipContent = toolTipElement.querySelector('.tool-tip__content');
        const toolTipInner = toolTipElement.querySelector('.tool-tip__inner');
        const closeButton = toolTipElement.querySelector('.tool-tip__close');

        if (toolTipContent) {
          const toolTipTrigger = toolTipContent.querySelector('tool-tip-trigger');
          if (toolTipTrigger) {
            const triggerContent = toolTipTrigger.querySelector('.tool-tip-trigger__content');
            if (triggerContent) {
              const modalContent = triggerContent.querySelector('.size-guide-modal');
              if (modalContent) {
                const clonedModal = modalContent.cloneNode(true);

                const overlay = clonedModal.querySelector('.size-guide-overlay');
                const container = clonedModal.querySelector('.size-guide-container');

                if (overlay) {
                  overlay.removeAttribute('x-show');
                  overlay.removeAttribute('@click');
                  overlay.removeAttribute('x-transition:enter');
                  overlay.removeAttribute('x-transition:enter-start');
                  overlay.removeAttribute('x-transition:enter-end');
                  overlay.removeAttribute('x-transition:leave');
                  overlay.removeAttribute('x-transition:leave-start');
                  overlay.removeAttribute('x-transition:leave-end');
                }

                if (container) {
                  container.removeAttribute('x-show');
                  container.removeAttribute('x-transition:enter');
                  container.removeAttribute('x-transition:enter-start');
                  container.removeAttribute('x-transition:enter-end');
                  container.removeAttribute('x-transition:leave');
                  container.removeAttribute('x-transition:leave-start');
                  container.removeAttribute('x-transition:leave-end');
                }

                clonedModal.removeAttribute('x-cloak');
                clonedModal.removeAttribute('x-data');
                clonedModal.removeAttribute('@show-size-guide.window');
                clonedModal.removeAttribute('@click.outside');
                clonedModal.removeAttribute('x-show');
                clonedModal.removeAttribute('x-effect');
                clonedModal.removeAttribute('x-transition:enter');
                clonedModal.removeAttribute('x-transition:enter-start');
                clonedModal.removeAttribute('x-transition:enter-end');
                clonedModal.removeAttribute('x-transition:leave');
                clonedModal.removeAttribute('x-transition:leave-start');
                clonedModal.removeAttribute('x-transition:leave-end');

                toolTipTrigger.remove();
                toolTipContent.appendChild(clonedModal);

                if (overlay) {
                  overlay.style.display = 'block';
                  overlay.style.opacity = '1';
                  overlay.addEventListener('click', (e) => {
                    e.stopPropagation();
                    closeSizeGuideModal();
                  });
                }
              }
            }
          }
        }

        if (closeButton) {
          closeButton.addEventListener('click', (e) => {
            e.stopPropagation();
            closeSizeGuideModal();
          });
        }

        sizeGuideModalCloseHandlers.overlayClick = (e) => {
          if (toolTipElement.getAttribute('data-tool-tip-open') === 'true') {
            if (toolTipInner && !toolTipInner.contains(e.target) && e.target !== closeButton) {
              closeSizeGuideModal();
            }
          }
        };

        document.addEventListener('click', sizeGuideModalCloseHandlers.overlayClick);

        sizeGuideModalCloseHandlers.escapeKey = (e) => {
          if (e.key === 'Escape' && toolTipElement.getAttribute('data-tool-tip-open') === 'true') {
            closeSizeGuideModal();
          }
        };

        document.addEventListener('keydown', sizeGuideModalCloseHandlers.escapeKey);

        if (window.theme && window.theme.a11y && window.theme.a11y.lockMobileScrolling) {
          window.theme.a11y.lockMobileScrolling();
        }
        document.documentElement.classList.add('modal-open');
        document.documentElement.classList.add('lock-scroll');
        document.body.classList.add('overflow-hidden');

        toolTipElement.setAttribute('data-tool-tip-open', 'true');
      };

      const sizeGuideLink = section.querySelector('.product-collection-showcase__size-guide-link');

      if (sizeGuideLink) {
        sizeGuideLink.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const detectedType = sizeGuideLink.getAttribute('data-size-guide-type');
          showSizeGuideModal(detectedType);
        });
      }

      const initializeSwiperWithSkeleton = () => {
        if (!mainSwiperElement) {
          setTimeout(() => initializeSwiperWithSkeleton(), 50);
          return;
        }

        if (typeof Swiper === 'undefined') {
          setTimeout(() => initializeSwiperWithSkeleton(), 100);
          return;
        }

        if (mainSwiperInstance && productWrapperElement.children.length > 0) {
          return;
        }

        if (mainSwiperInstance) {
          mainSwiperInstance.destroy(true, true);
          mainSwiperInstance = null;
        }

        const slidesPerViewCount = getSlidesPerView();
        const spaceBetweenSlides = 0;

        try {
          mainSwiperInstance = new Swiper(mainSwiperElement, {
            slidesPerView: slidesPerViewCount,
            spaceBetween: spaceBetweenSlides,
            slidesPerGroup: 1,
            freeMode: false,
            grabCursor: true,
            width: null,
            autoHeight: false,
            resistance: true,
            resistanceRatio: 0.85,
            speed: 300,
            loop: false,
            allowTouchMove: false,
            pagination: paginationEl
              ? {
                  el: paginationEl,
                  clickable: true,
                }
              : false,
            on: {
              init: function () {
                updateProgressBar(this);
                if (progressBar) setupProgressBarDrag(progressBar, this);
              },
              slideChange: function () {
                updateProgressBar(this);
              },
              progress: function () {
                updateProgressBar(this);
              },
            },
          });

          setTimeout(() => {
            if (mainSwiperInstance) {
              mainSwiperInstance.update();
            }
          }, 50);
        } catch (error) {
          setTimeout(() => initializeSwiperWithSkeleton(), 200);
        }
      };

      const initializeSkeletonState = () => {
        if (!mainSwiperElement || !productWrapperElement) {
          setTimeout(() => initializeSkeletonState(), 50);
          return;
        }

        const skeletonElements = productWrapperElement.querySelectorAll('[data-skeleton]');
        if (skeletonElements.length === 0) {
          return;
        }

        initializeSwiperWithSkeleton();
      };

      initializeSkeletonState();

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          if (!mainSwiperInstance) {
            initializeSkeletonState();
          }
          setTimeout(function () {
            loadAndRenderProducts();
          }, 300);
        });
      } else {
        setTimeout(function () {
          loadAndRenderProducts();
        }, 300);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-product-collection-showcase-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      const section = document.querySelector(
        '[data-product-collection-showcase-section][data-section-id="' + e.detail.sectionId + '"]',
      );
      if (section) {
        initSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initSection(section) {
      if (!section || !section.hasAttribute('data-testimonials-section')) return;

      const swiperElement = section.querySelector('[data-testimonials-swiper]');
      const paginationBars = section.querySelectorAll('[data-pagination-index]');

      let swiperInstance = null;
      let wheelListenerAdded = false;
      let lastWheelSlideTime = 0;
      const WHEEL_COOLDOWN_MS = 400;

      function destroySwiper() {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }

      function initSwiper() {
        if (!swiperElement || typeof Swiper === 'undefined') {
          if (typeof Swiper === 'undefined') {
            setTimeout(initSwiper, 100);
          }
          return;
        }

        destroySwiper();

        swiperInstance = new Swiper(swiperElement, {
          slidesPerView: 1,
          spaceBetween: 16,
          loop: false,
          speed: 300,
          allowTouchMove: true,
          on: {
            init: function () {
              updatePagination(this.activeIndex);
              updateSlideBackground(this.activeIndex);
              if (!wheelListenerAdded && swiperElement) {
                wheelListenerAdded = true;
                swiperElement.addEventListener(
                  'wheel',
                  function (e) {
                    if (!swiperInstance) return;
                    const isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
                    if (!isHorizontal) return;
                    e.preventDefault();
                    const threshold = 15;
                    if (Math.abs(e.deltaX) < threshold) return;
                    const now = Date.now();
                    if (now - lastWheelSlideTime < WHEEL_COOLDOWN_MS) return;
                    lastWheelSlideTime = now;
                    if (e.deltaX > 0) {
                      if (!swiperInstance.isEnd) swiperInstance.slideNext();
                    } else {
                      if (!swiperInstance.isBeginning) swiperInstance.slidePrev();
                    }
                  },
                  { passive: false },
                );
              }
            },
            slideChange: function () {
              updatePagination(this.activeIndex);
              updateSlideBackground(this.activeIndex);
            },
          },
        });
      }

      function updatePagination(activeIndex) {
        paginationBars.forEach(function (bar, index) {
          const isActive = index === activeIndex;
          bar.classList.toggle('testimonials__pagination-bar--active', isActive);
          bar.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      function loadSlideBackgroundImages(slideEl) {
        if (!slideEl) return;
        slideEl.querySelectorAll('img[data-src]').forEach(function (img) {
          const src = img.getAttribute('data-src');
          if (src) {
            img.src = src;
            img.removeAttribute('data-src');
          }
        });
      }

      function updateSlideBackground(activeIndex) {
        const container = section.querySelector('[data-testimonials-slide-backgrounds]');
        if (!container) return;
        container.querySelectorAll('[data-slide-index]').forEach(function (el) {
          const index = parseInt(el.getAttribute('data-slide-index'), 10);
          const isActive = index === activeIndex;
          el.classList.toggle('testimonials__slide-bg--active', isActive);
          if (isActive) {
            loadSlideBackgroundImages(el);
          }
        });
      }

      initSwiper();

      var container = section.querySelector('[data-testimonials-slide-backgrounds]');
      if (container) {
        var firstSlide = container.querySelector('[data-slide-index="0"]');
        if (firstSlide) {
          loadSlideBackgroundImages(firstSlide);
        }
      }
      if (swiperInstance) {
        updateSlideBackground(swiperInstance.activeIndex);
      }

      paginationBars.forEach(function (bar, index) {
        bar.addEventListener('click', function () {
          if (swiperInstance) {
            swiperInstance.slideTo(index);
            updatePagination(index);
            updateSlideBackground(index);
          }
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-testimonials-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      const section = document.querySelector(
        '[data-testimonials-section][data-section-id="' + e.detail.sectionId + '"]',
      );
      if (section) {
        initSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
